import * as Backbone from "backbone";
import {invokeLast} from 'util/FuncUtil';

export const SearchFieldView = Backbone.View.extend({
	tagName: 'input',
	inputDelay: 300,
	events: {
		"keyup": "keyupHandler",
		"mouseup": "keyupHandler",
	},
	initialize: function () {
		if (!this.model) this.model = new Backbone.Model();
	},
	keyupHandler: function () {
		invokeLast(this, 'refreshFilter', this.inputDelay);
	},
	refreshFilter: function () {
		let val = this.$el.val();
		val = val && val.trim();
		this.model.set({value: val});
	},
});